import { HttpStatusCode } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
    AnnualReportMetaInformationDTO,
    AnnualReportNavigationProvider,
    AnnualReportProvider,
    GetShareDto,
    declineSharedAnnualReport,
    getNextBalanceSheetDateForCompanyById,
    onCreateAnnualReportSuccessfully,
    shareAnnualReport,
} from '@modeso/aumico-lib-annualreport-fe';
import { CompaniesProvider, PersonsProvider, TagsProvider } from '@modeso/aumico-lib-companies-fe';
import {
    AnnualReportShareInvitationActions,
    AumGlobalAction,
    EMPTY_ARRAY_LENGTH,
    IAumGlobalActionEvent,
    IInvitationDialogData,
    IPageHeader,
    ModalComponent,
    ModalData,
    ModalTitleIcons,
    ReportType,
} from '@modeso/aumico-lib-core-fe';
import {
    GetOrganizationDto,
    GetUserDto,
    IUserPreferences,
    OrganizationProvider,
    agreeToTerms
} from '@modeso/aumico-lib-users-fe';
import { CPMMState } from '@modeso/aumico-lib-users-fe/enums/cpmm-state.enum';
import {
    AnnualReportStep,
    ISetupData,
    WorkflowConfigurationSelectionEnum,
} from '@modeso/types__aumico-lib-annualreport-be';
import { ICompanyDTO, ICompanyNameIdLegalFormDTO } from '@modeso/types__aumico-lib-companies-be';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { I18NextService } from 'angular-i18next';
import Debug from 'debug';
import { cloneDeep } from 'lodash-es';
import {
    Subject,
    combineLatest,
    concatMap,
    filter,
    from,
    ignoreElements,
    map,
    mapTo,
    merge,
    mergeMap,
    of,
    pairwise,
    startWith,
    switchMap,
    take,
    takeUntil,
    takeWhile,
    tap,
    timer
} from 'rxjs';
import { acceptSharedAnnualReport } from '../../../../../../aumico-lib-annualreport-fe/src/lib/actions/annualreport-shares.action';
import { TasksOverviewState } from '../../../../../../aumico-lib-cpmm-fe/src/lib';
import { TasksOverviewActions } from '../../../../../../aumico-lib-cpmm-fe/src/lib/actions/tasks.actions';
import {
    setProjectNavigationContext,
    setProjectsFilter,
    setScrollToTextState,
    setSelectedTabState,
} from '../../../../../../aumico-lib-cpmm-fe/src/lib/actions/ui.actions';
import { SortDirection } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/sort-direction.enum';
import { WorkflowArea } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/workflow-area.enum';
import { selectTasksByProjectId } from '../../../../../../aumico-lib-cpmm-fe/src/lib/reducers/tasks.reducer';
import {
    selectProjectNavigationContext,
    selectProjectsFilter,
} from '../../../../../../aumico-lib-cpmm-fe/src/lib/reducers/ui.reducer';
import {
    BulkDeleteDependencyWarning,
    ProjectOverviewTableValue,
    ProjectsOverviewActions,
    ProjectsOverviewState,
    selectProjectsOverview,
    selectTotalCount,
} from '../../../../../../aumico-lib-projects-fe/src/lib';
import { activeNavigation } from '../../../../../../aumico-lib-projects-fe/src/lib/enums/activeNavigation.enum';
import { ProjectSortingProperties } from '../../../../../../aumico-lib-projects-fe/src/lib/enums/project-sorting-properties.enum';
import { ProjectStatus } from '../../../../../../aumico-lib-projects-fe/src/lib/enums/project-status.enum';
import { ProjectsFilter } from '../../../../../../aumico-lib-projects-fe/src/lib/interfaces/projects-filter.interface';
import { MixpanelService } from '../../../../../../mixpanel/mixpanel.service';
import { MIXPANEL_EVENTS } from '../../../../../../mixpanel/mixpanelEvents.enum';
import { AcceptPolicyDialogComponent } from '../../../components/accept-policy-dialog/accept-policy-dialog.component';
import { AcceptPolicyToContinueUsingAumicoDialogComponent } from '../../../components/accept-policy-to-continue-using-aumico-dialog/accept-policy-to-continue-using-aumico-dialog.component';
import { AssigneeFilter } from '../../../enums/assigneeFilter.enum';
import { Paths } from '../../../enums/paths.enum';
import { RouteLabels } from '../../../enums/routeLabels.enum';
import { AnnualReportOrchestrator } from '../../../orchestrator/annualreport.orchestrator';
import { InvitationBasePage } from '../../../pages/shared-pages/invitation-base.page';
import { ResetStoreService } from '../../../shared/services/resetStore.service';
import { ProjectsOverviewHelper } from '../helpers/projects-overview.helper';

const debug = Debug('aumico:projects:ProjectsOverviewPage');
type ShareDialogResponseData = {
    action: AnnualReportShareInvitationActions;
    share: GetShareDto;
    shareIndex: number;
};
@UntilDestroy()
@Component({
    selector: 'app-page-projects-overview',
    templateUrl: 'projects-overview.page.html',
    styleUrls: ['projects-overview.page.scss'],
})
export class ProjectsOverviewPage extends InvitationBasePage implements OnInit {
    displayAllProjects: boolean = false;
    projectsFilter: ProjectsFilter | undefined = {};
    limit = 1000000;
    offset = 0;
    assigneeOptions: INameId[] = [];
    searchedAssigneeOptions: INameId[] = [];
    projectsOverviewTableData: ProjectOverviewTableValue[] = [];
    annualReportsMetaInformationRecords: AnnualReportMetaInformationDTO[] = [];

    private shouldNavigateToEditPage = false;
    readonly pageHeader: IPageHeader = {
        isLocalizedKey: true,
        value: RouteLabels.PROJECT_LIST,
    };

    viewOnlyMode = true;
    dialogRef: any;
    currentDialogIndex: number;
    shares: GetShareDto[];

    private closePolicyDialog = new Subject<boolean>();
    private language: string | undefined;

    public userPreferredNumberOfDocumentsPerPage: number | undefined;
    private userPreferences: IUserPreferences | undefined;

    public showCreateProjectPopup = false;
    public companiesList: ICompanyNameIdLegalFormDTO[] = [];

    public balanceSheetDate: Date | undefined;
    private selectedCompanyDto: ICompanyDTO | undefined;
    private reportType: ReportType | undefined;
    private pendingReportType: ReportType | undefined;
    public isCpmmActive: boolean = false;
    public isMandateAndTaskManagementEnabled: boolean = false;
    public mandateManagementWorkflow: WorkflowConfigurationSelectionEnum;
    public closingWorkflow: WorkflowConfigurationSelectionEnum;
    public isAutofillReport = false;

    statusOptions = [
        { label: 'Active', value: ProjectStatus.ACTIVE },
        { label: 'Done', value: ProjectStatus.DONE },
        { label: 'Archived', value: ProjectStatus.ARCHIVED },
    ];

    companiesOptions: {
        id: string;
        name: string;
    }[] = [];
    activeProjectId: string;
    isCreatingAnnualReport: boolean;

    searchedCompaniesOptions: {
        id: string;
        name: string;
    }[] = [];

    activeNavigation: string = activeNavigation.MY_PROJECTS;
    assigneeFilter: string[] = [];

    allProjectsSelected: boolean = false;
    selectedProjects: Set<string> = new Set<string>();

    // Variables for bulk edit
    bulkActions = [{ id: 'STATUS_CHANGE', translationKey: 'aumico_project_status_change_action_bar' }];
    deleteAction = { id: 'DELETE_PROJECTS', translationKey: 'aumico_project_delete_action_bar' };

    openBulkEditStatus: boolean = false;
    openBulkDeleteConfirmationDialog: boolean = false;
    openBulkDeleteDependencyWarningDialog: boolean = false;
    pendingDependencyWarnings: BulkDeleteDependencyWarning[] = [];
    pendingForceDeleteIds: string[] = [];
    possibleStatus = [
        {
            id: 'active',
            name: this.i18next.t('aumico_projects_status_active') as string,
        },
        {
            id: 'done',
            name: this.i18next.t('aumico_projects_status_done') as string,
        },
    ];
    bulkEditStatusControl = this.fb.control(null);
    openAutoTaskUpdateDialog = false;

    // REV-22155 — "Firmen / Personen", only when the organization has persons.
    hasPersons = false;
    /** REV-22155 — filter and column "Tag", only when the organization has tags. */
    showTags = false;
    /** ABCP organisations see one Jahresabschluss column instead of the closing-workflow sections. */
    abcpClosing = false;
    tagOptions: { id: string; name: string }[] = [];
    private tagIdsByCompanyId = new Map<string, string[]>();
    private tagNamesById: Record<string, string> = {};
    readonly subjectToggleOptions = [
        { value: 'COMPANY', label: this.i18next.t('aumico_projects_toggle_companies') as string },
        { value: 'PERSON', label: this.i18next.t('aumico_projects_toggle_persons') as string },
    ];

    constructor(
        injector: Injector,
        dialog: MatDialog,
        protected override router: Router,
        private i18next: I18NextService,
        private readonly annualReportProvider: AnnualReportProvider,
        private readonly companiesProvider: CompaniesProvider,
        private readonly annualReportNavigationProvider: AnnualReportNavigationProvider,
        private readonly resetStoreService: ResetStoreService,
        private readonly orchestratorOfAnnualReport: AnnualReportOrchestrator,
        private readonly mixpanelService: MixpanelService,
        private readonly sharesDialog: MatDialog,
        private readonly organizationProvider: OrganizationProvider,
        private store: Store<ProjectsOverviewState>,
        private tasksStore: Store<TasksOverviewState>,
        private fb: FormBuilder,
        private readonly personsProvider: PersonsProvider,
        private readonly tagsProvider: TagsProvider,
    ) {
        super(injector, dialog);
        this.statusOptions[0].label = this.i18next.t('aumico_projects_status_active') as string;
        this.statusOptions[1].label = this.i18next.t('aumico_projects_status_done') as string;
        this.statusOptions[2].label = this.i18next.t('aumico_projects_status_archived') as string;

        this.authProvider
            .getCurrentUserRoles$()
            .pipe(filter((roles) => roles != null), untilDestroyed(this))
            .subscribe((roles: string[]) => {
                this.handleCurrentUserRolesPermissions(roles);
            });

        this.authProvider
            .getCurrentUser$()
            .pipe(untilDestroyed(this))
            .subscribe((user) => {
                if (user == null) {
                    this.authProvider.dispatchGetCurrentUser();
                    return;
                }
                this.language = user.locale;
                if (!user.hasAcceptedLatestPolicy) {
                    this.openPolicyUpdateDialog();
                }
            });

        this.actionsListener$.pipe(ofType(agreeToTerms.success), untilDestroyed(this)).subscribe(() => {
            this.closePolicyDialog.next(true);
            this.authProvider.dispatchGetCurrentUser();
        });
    }

    override ngOnInit() {
        super.ngOnInit();
        this.resetNeededStores();

        this.userPreferences = this.localStorageService.getUserPrefrences();
        this.userPreferredNumberOfDocumentsPerPage = this.userPreferences?.numberOfDocumentsPerPage;

        this.organizationProvider.dispatchGetUsers(true);
        this.organizationProvider.dispatchGetCurrentOrganization();

        this.activeUserAumicoInternalId$
            .pipe(
                filter((id): id is string => !!id),
                untilDestroyed(this),
            )
            .subscribe((id) => {
                debug('refetchProjects Active User Aumico Internal ID:', id);
                this.refetchProjects();
            });

        this.annualReportProvider.dispatchActiveAnnualReportsList();

        this.actionsListener$
            .pipe(
                ofType(getNextBalanceSheetDateForCompanyById.getNextBalanceSheetDateForCompanyByIdSuccess),
                filter((payload) => payload?.payload != null),
                untilDestroyed(this),
            )
            .subscribe((payload) => {
                const dateString = payload.payload;  // This is a string

                // Parse the date string as UTC to extract year, month, day without timezone interference
                const utcDate = new Date(dateString);
                this.balanceSheetDate = new Date(Date.UTC(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate(), 0, 0, 0, 0));

                this.mandateManagementWorkflow =
                    WorkflowConfigurationSelectionEnum.COPY_CONFIGURATION_FROM_PREVIOUS_YEAR;
                this.closingWorkflow = WorkflowConfigurationSelectionEnum.COPY_CONFIGURATION_FROM_PREVIOUS_YEAR;
            });

        this.organizationProvider
            .getCurrentOrganization$()
            .pipe(
                filter((organization) => organization != null),
                untilDestroyed(this),
            )
            .subscribe((organization: GetOrganizationDto) => {
                this.isCpmmActive = organization.cpmmActivationDetails?.activationState === CPMMState.ACTIVE;
                this.isMandateAndTaskManagementEnabled = organization.isMandateAndTaskManagementEnabled ?? false;
                this.abcpClosing = organization.abcpPreview === true;
            });

        this.companiesProvider
            .getSelectedCompanyById$()
            .pipe(
                filter((company) => company != null),
                untilDestroyed(this),
            )
            .subscribe((company) => {
                this.selectedCompanyDto = cloneDeep<ICompanyDTO>(company);
                if (this.pendingReportType) {
                    this.dispatchNextBalanceSheetDateForCompany(this.pendingReportType);
                }
            });

        this.companiesProvider
            .getCompaniesNameIdLegalForm$()
            .pipe(untilDestroyed(this))
            .subscribe((companies) => {
                this.companiesList = companies;

                this.companiesOptions = companies.map((company) => ({
                    id: company._id,
                    name: company.name,
                }));
                this.searchedCompaniesOptions = cloneDeep(this.companiesOptions);
            });

        this.companiesProvider.dispatchCompaniesNameIdLegalFormList();

        this.personsProvider.dispatchPersonsList();
        this.personsProvider
            .getPersons$()
            .pipe(untilDestroyed(this))
            .subscribe((persons) => (this.hasPersons = persons.length > 0));

        combineLatest([this.companiesProvider.getCompanies$(), this.tagsProvider.getTagNamesById$()])
            .pipe(untilDestroyed(this))
            .subscribe(([companies, tagNamesById]) => {
                this.tagIdsByCompanyId = new Map((companies ?? []).map((company) => [company._id, company.tags ?? []]));
                this.tagNamesById = tagNamesById ?? {};
                this.tagOptions = Object.entries(this.tagNamesById).map(([id, name]) => ({ id, name }));
                this.showTags = this.tagOptions.length > 0;
                this.projectsOverviewTableData = this.withTags(this.projectsOverviewTableData);
            });
        this.companiesProvider.dispatchCompaniesList();
        this.tagsProvider.dispatchTagsList();

        this.shareAnnualReportProvider.dispatchGetCurrentActiveUserSharedAnnualReports();

        this.actionsListener$
            .pipe(
                ofType(onCreateAnnualReportSuccessfully),

                //   setActiveProjectId
                tap(({ payload }) => {
                    this.store.dispatch(
                        ProjectsOverviewActions.setActiveProjectId({
                            projectId: payload.projectId,
                        }),
                    );
                    this.activeProjectId = payload.projectId;
                }),

                switchMap(({ payload }) => {
                    if (!this.isCpmmActive || !this.isMandateAndTaskManagementEnabled) {
                        // skip all task-loading logic
                        return of(payload);
                    }

                    const stopPolling$ = new Subject<void>();

                    // polling stream: dispatch loadProjectTasks every 1s until stopPolling$
                    const poll$ = timer(3000, 1000).pipe(
                        takeUntil(stopPolling$),
                        tap(() =>
                            this.tasksStore.dispatch(
                                TasksOverviewActions.loadProjectTasks({
                                    projectId: this.activeProjectId,
                                    filter: { offset: 0, limit: 1000 },
                                }),
                            ),
                        ),
                        ignoreElements(),
                    );

                    // stabilization watcher: watch tasks$.length → when two in a row match
                    const stable$ = this.store.select(selectTasksByProjectId(this.activeProjectId)).pipe(
                        map((list) => list.length),
                        startWith(-1),
                        pairwise(),
                        filter(([prev, curr]) => prev === curr),
                        take(1),
                        tap(() => {
                            stopPolling$.next();
                            stopPolling$.complete();
                        }),
                        mapTo(payload), // emit the payload through
                    );

                    // merge and only take one emission (the payload once stable)
                    return merge(poll$, stable$).pipe(take(1));
                }),

                //  stop showing "creating" UI
                tap(() => (this.isCreatingAnnualReport = false)),

                switchMap((payload) =>
                    // first set it
                    of(null).pipe(
                        tap(() => {
                            this.annualReportProvider.setActiveAnnualReportEncryptedId(payload.annualReportEncryptedId);
                        }),
                        // then fetch the encryptedId back
                        switchMap(() => this.annualReportProvider.getActiveAnnualReportEncryptedId$()),
                    ),
                ),

                untilDestroyed(this),
            )
            .subscribe((encryptedId) => {
                this.shouldNavigateToEditPage = true;
                this.orchestratorOfAnnualReport.load(encryptedId);
            });

        this.actionsListener$
            .pipe(ofType(acceptSharedAnnualReport.failure, declineSharedAnnualReport.failure), untilDestroyed(this))
            .subscribe(({ payload }) => {
                if (payload.status === HttpStatusCode.NotFound) {
                    this.fireErrorMessage('aumico_reports_share_not_found');
                } else {
                    this.fireErrorMessage();
                }

                if (this.currentDialogIndex === this.shares.length - 1) {
                    this.annualReportProvider.dispatchActiveAnnualReportsList();
                }
            });

        this.actionsListener$
            .pipe(ofType(acceptSharedAnnualReport.success, declineSharedAnnualReport.success), untilDestroyed(this))
            .subscribe(() => {
                if (this.currentDialogIndex === this.shares.length - 1) {
                    this.annualReportProvider.dispatchActiveAnnualReportsList();
                }
            });

        this.shareAnnualReportProvider
            .selectSharedAnnualReport$()
            .pipe(untilDestroyed(this))
            .subscribe((shares) => {
                if (shares != undefined && shares.length > EMPTY_ARRAY_LENGTH) {
                    this.shares = shares;
                    this.openAcceptAndDeclineSharesDialogs(shares);
                }
            });

        this.annualReportProvider
            .getActiveAnnualReport$()
            .pipe(
                filter((annualReport) => annualReport != null),
                mergeMap((annualReport) =>
                    this.annualReportProvider
                        .getActiveMetaInformation$()
                        .pipe(map((metaInformation) => ({ annualReport, metaInformation }))),
                ),
                untilDestroyed(this),
            )
            .subscribe(({ annualReport, metaInformation }) => {
                const urlParts = this.router.url.split('/');
                urlParts.pop();
                const newUrl = urlParts.join('/');
                const backroute = this.router.url;

                const isInterimReport =
                    annualReport.setupData?.reportType === ReportType.QUARTERLY ||
                    annualReport.setupData?.reportType === ReportType.MONTHLY ||
                    annualReport.setupData?.reportType === ReportType.CUSTOM;

                // Navigate to edit page - activeProjectId should now be properly set
                // This is used when we create a new project
                if (
                    this.shouldNavigateToEditPage &&
                    !(metaInformation && metaInformation.isSealed) &&
                    (!this.isCpmmActive || !this.isMandateAndTaskManagementEnabled || isInterimReport)
                ) {
                    this.router.navigateByUrl(
                        `${newUrl}/${this.activeProjectId}?backTarget=${encodeURIComponent(backroute)}`,
                    );
                } else if (
                    this.shouldNavigateToEditPage &&
                    !(metaInformation && metaInformation.isSealed) &&
                    this.isCpmmActive &&
                    this.isMandateAndTaskManagementEnabled &&
                    !isInterimReport
                ) {
                    this.router.navigateByUrl(
                        `${newUrl}/${this.activeProjectId}/cpmm?backTarget=${encodeURIComponent(backroute)}`,
                    );
                } else if (this.shouldNavigateToEditPage && metaInformation.isSealed) {
                    this.annualReportNavigationProvider.setActiveArNavigation([AnnualReportStep.PRINT], true);

                    if (this.isCpmmActive && this.isMandateAndTaskManagementEnabled) {
                        this.router.navigateByUrl(
                            `${newUrl}/${this.activeProjectId}/cpmm/report/${Paths.PRINT
                            }?backTarget=${encodeURIComponent(backroute)}`,
                        );
                    } else {
                        this.router.navigateByUrl(
                            `${newUrl}/${this.activeProjectId}/${Paths.PRINT}?backTarget=${encodeURIComponent(
                                backroute,
                            )}`,
                        );
                    }
                }
            });

        this.actionsListener$.pipe(ofType(shareAnnualReport.success), untilDestroyed(this)).subscribe(({ payload }) => {
            if (payload && this.hasFailedEmails(payload.failedShares)) {
                this.onHasFailedMails(payload.failedShares);
            } else {
                this.fireSuccessNotification({
                    titleKey: this.i18n.t('aumico_reports_share_annual_report_success_notification_title') as string,
                    descriptionKey: this.i18n.t(
                        'aumico_reports_share_annual_report_success_notification_description',
                    ) as string,
                });
            }
        });

        this.actionsListener$.pipe(ofType(shareAnnualReport.failure), untilDestroyed(this)).subscribe(() => {
            this.fireErrorMessage();
        });

        combineLatest([
            this.store.select(selectProjectsOverview),
            this.store.select(selectTotalCount),
            // Add the organization directly to combineLatest instead of using withLatestFrom
            this.organizationProvider.getCurrentOrganization$().pipe(
                filter((org) => org != null),
                map((org) => org.cpmmActivationDetails?.activationState === CPMMState.ACTIVE),
                startWith(false) // Provide a default value
            ),
        ])
            .pipe(
                // Filter to wait until all data is available
                // filter(([projectsMetaInformation, totalCount, isCpmmActive]) =>
                //     projectsMetaInformation.length > 0
                // ),

                // Switch to get users with deleted flag
                switchMap(([projectsMetaInformation, totalCount, isCpmmActive]) =>
                    this.organizationProvider.getUsers().pipe(
                        filter((users) => users.length > 0), // wait until users are loaded
                        map((users: GetUserDto[]) => {
                            // Create userMap with ALL users (including deleted) for display lookups
                            const userMap = new Map<string, GetUserDto>();
                            users.forEach(user => userMap.set(user.id, user));

                            // Build assigneeOptions using only ACTIVE users for dropdowns
                            this.assigneeOptions = [];

                            const userOptions = users
                                .filter(user => !user.isDeleted && !user.isInvitee)
                                .map((user) => ({
                                    id: user.id,
                                    name: user.firstName + ' ' + user.lastName,
                                    isMe: user.isMe,
                                }));

                            userOptions.unshift({
                                id: AssigneeFilter.unassigned,
                                name: this.i18next.t('aumico_tasks_unassigned') as string,
                                isMe: false,
                            });

                            // Add current user to the top of the list
                            const index = userOptions.findIndex((user) => user.isMe === true);
                            if (index > -1) {
                                const [item] = userOptions.splice(index, 1);
                                userOptions.unshift(item);
                            }

                            this.assigneeOptions.push(...userOptions);
                            this.searchedAssigneeOptions = cloneDeep(this.assigneeOptions);

                            const updated: ProjectOverviewTableValue[] = cloneDeep(
                                projectsMetaInformation.map((project) => {
                                    const assignedUser = userMap.get(project.assignee);
                                    const clerkUser = userMap.get(project.clerk);
                                    return {
                                        ...project,
                                        assignee: assignedUser
                                            ? `${assignedUser.firstName} ${assignedUser.lastName}`
                                            : (this.i18next.t('aumico_tasks_unassigned') as string),
                                        assigneeDeleted: assignedUser?.isDeleted ?? false,
                                        clerk: clerkUser
                                            ? `${clerkUser.firstName} ${clerkUser.lastName}`
                                            : (this.i18next.t('aumico_tasks_unassigned') as string),
                                        clerkDeleted: clerkUser?.isDeleted ?? false,
                                        workflowData: isCpmmActive && this.isMandateAndTaskManagementEnabled ? project.workflowData : null,
                                    };
                                }),
                            );

                            return updated;
                        }),
                    ),
                ),

                untilDestroyed(this),
            )
            .subscribe((projectsMetaInformationRecords) => {
                // Store previous state for smart cleanup
                const previousProjectIds = new Set<string>();
                if (this.projectsOverviewTableData.length > 0) {
                    this.projectsOverviewTableData.forEach((project) => {
                        previousProjectIds.add(project.projectId);
                    });
                }

                // Update the data
                this.projectsOverviewTableData = this.withTags(cloneDeep(projectsMetaInformationRecords));

                // Smart cleanup: Remove selections for projects no longer visible after filtering
                if (previousProjectIds.size > 0 && (this.selectedProjects.size > 0 || this.allProjectsSelected)) {
                    this.cleanupInvalidSelections();
                }
            });

        this.actionsListener$
            .pipe(ofType(ProjectsOverviewActions.projectStatusUpdated), untilDestroyed(this))
            .subscribe(() => {
                this.fireSuccessNotification({
                    descriptionKey: this.i18next.t('aumico_project_overview_status_update_success_message') as string,
                });
            });

        this.actionsListener$
            .pipe(ofType(ProjectsOverviewActions.projectStatusUpdateFailure), untilDestroyed(this))
            .subscribe(() => {
                this.fireErrorMessage(this.i18next.t('aumico_project_overview_status_update_error_message') as string);
            });

        this.actionsListener$
            .pipe(ofType(ProjectsOverviewActions.projectDeleted), untilDestroyed(this))
            .subscribe(() => {
                this.refetchProjects();
                this.fireSuccessNotification({
                    descriptionKey: this.i18next.t('aumico_project_overview_project_delete_success_message') as string,
                });
            });

        this.actionsListener$
            .pipe(ofType(ProjectsOverviewActions.projectDeleteFailure), untilDestroyed(this))
            .subscribe((payload) => {
                const message: string = payload.error?.error?.message ?? '';
                if (message.includes('aumico_backend_errors_project_deletion_due_to_dependency') && payload.projectId) {
                    const reportsStr = message.split(':').slice(1).join(':').trim();
                    const dependentReports = reportsStr ? reportsStr.split(', ').filter(Boolean) : [];
                    this.pendingDependencyWarnings = [{ projectId: payload.projectId, dependentReports }];
                    this.pendingForceDeleteIds = [payload.projectId];
                    this.openBulkDeleteDependencyWarningDialog = true;
                } else {
                    this.fireErrorMessage(this.i18next.t('aumico_project_overview_project_delete_error_message') as string);
                }
            });

        // Asks whether to delete projects that other reports build on.
        this.actionsListener$
            .pipe(ofType(ProjectsOverviewActions.bulkProjectsDeleted), untilDestroyed(this))
            .subscribe(({ warnings }) => {
                const safeWarnings = Array.isArray(warnings) ? warnings : [];
                this.pendingDependencyWarnings = safeWarnings;
                this.openBulkDeleteDependencyWarningDialog = safeWarnings.length > 0;
                this.pendingForceDeleteIds = safeWarnings.map((w) => w.projectId);
            });

        this.annualReportProvider
            .getAnnualReports$()
            .pipe(untilDestroyed(this))
            .subscribe((annualReportsMetaInformationRecords) => {
                this.annualReportsMetaInformationRecords = cloneDeep<AnnualReportMetaInformationDTO[]>(
                    annualReportsMetaInformationRecords,
                );
            });

        this.store
            .select(selectProjectsFilter())
            .pipe(untilDestroyed(this))
            .subscribe((projectsFilter) => {
                if (this.assigneeFilter === undefined || this.assigneeFilter.length === 0) {
                    this.assigneeFilter = projectsFilter.assignee;
                }
                this.projectsFilter = cloneDeep({
                    ...projectsFilter,
                });
                this.refetchProjects();
            });

        this.store
            .select(selectProjectNavigationContext())
            .pipe(untilDestroyed(this))
            .subscribe((context) => {
                const target = context.context;
                if (target === 'my-projects') {
                    this.onDisplayMyProjects(false);
                    this.refetchProjects();
                } else if (target === 'all-projects' || target === 'all-proecjts') {
                    // Handle both correct spelling and potential typo
                    this.onDisplayAllProjects(false);
                    this.refetchProjects();
                }
            });
    }

    private openAcceptAndDeclineSharesDialogs(shares: GetShareDto[]) {
        from(shares)
            .pipe(
                concatMap((share, shareIndex) => {
                    const dialogRef = this.sharesDialog.open<
                        ModalComponent,
                        ModalData,
                        AnnualReportShareInvitationActions
                    >(ModalComponent, {
                        disableClose: true,
                        panelClass: 'custom-modalbox',
                        data: {
                            showCloseButton: false,
                            titleIcon: ModalTitleIcons.INFO,
                            footerButtons: [
                                {
                                    localizationKey: 'aumico_reports_share_annual_report_dialog_accept_button',
                                    action: AnnualReportShareInvitationActions.ACCEPT_SHARE,
                                    buttonColor: 'primary',
                                },
                                {
                                    localizationKey: 'aumico_reports_share_annual_report_dialog_decline_button',
                                    action: AnnualReportShareInvitationActions.DECLINE_SHARE,
                                    buttonColor: 'basic',
                                },
                            ],
                            content: {
                                text: [share.fromOrganizationName, 'aumico_reports_share_annual_report_dialog_text'],
                                icon: 'document-information',
                            },
                        },
                    });

                    return dialogRef.afterClosed().pipe(map((action) => ({ action, share, shareIndex })));
                }),

                takeWhile(Boolean),
            )
            .subscribe(({ action, share, shareIndex }: ShareDialogResponseData) => {
                if (action === AnnualReportShareInvitationActions.ACCEPT_SHARE) {
                    this.shareAnnualReportProvider.dispatchAcceptSharedAnnualReport(share.id);
                } else {
                    this.shareAnnualReportProvider.dispatchDeclineSharedAnnualReport(share.id);
                }
                this.currentDialogIndex = shareIndex;
            });
    }

    private handleCurrentUserRolesPermissions(roles: string[]): void {
        if (roles.includes('ORG_USER') || roles.includes('ORG_ADMIN')) {
            this.viewOnlyMode = false;

            return;
        }
        this.viewOnlyMode = true;
    }

    createAnnualReport(setupData: ISetupData): void {
        debug('create new annual report');
        this.mixpanelService.track(MIXPANEL_EVENTS.CREATE_ANNNUAL_REPORT_BUTTON_CLICK);
        this.orchestratorOfAnnualReport.new(setupData);

        const event: IAumGlobalActionEvent = {
            action: AumGlobalAction.UPDATECURRENTENTITY,
            value: 'New',
        };
        this.actionHeaderService.onAction(event);
        this.isCreatingAnnualReport = true;
    }

    onSelectProject(selection: {
        project: ProjectOverviewTableValue;
        area?: WorkflowArea | 'report' | 'closing';
        section?: string;
        sectionClosingProcess?: string;
    }): void {
        const annualReportMeta = this.annualReportsMetaInformationRecords.find(
            (arMeta) => arMeta._id === selection.project.annualReportMetaData,
        );

        if (annualReportMeta && annualReportMeta.annualReportEncryptedId) {
            this.annualReportProvider.setActiveAnnualReportEncryptedId(annualReportMeta.annualReportEncryptedId);
            this.orchestratorOfAnnualReport.load(annualReportMeta.annualReportEncryptedId);
        }

        this.shouldNavigateToEditPage = true;

        // We should not load the data here, instead it shall be loaded on the fs edit page
        // Here we should simply navigate to mandate management page
        this.store.dispatch(ProjectsOverviewActions.setActiveProjectId({ projectId: selection.project.projectId }));
        this.store.dispatch(
            ProjectsOverviewActions.fetchProjectDataByProjectId({
                projectId: selection.project.projectId,
            }),
        );
        if (selection.area && selection.area === WorkflowArea.MANDATE_MANAGEMENT && selection.section) {
            this.store.dispatch(setScrollToTextState({ text: selection.section }));
        }
        if (selection.area && selection.area === WorkflowArea.CLOSING_PROCESS && selection.section) {
            this.store.dispatch(
                setSelectedTabState({
                    locationId: selection.project.projectId + '__' + selection.area,
                    selectedTabKey: selection.section,
                }),
            );
            this.store.dispatch(setScrollToTextState({ text: selection.sectionClosingProcess }));
        }
        // Navigate to edit page
        const urlParts = this.router.url.split('/');
        urlParts.pop();
        const newUrl = urlParts.join('/');
        const backroute = this.router.url;

        const isInterimReport =
            selection.project.reportType === ReportType.QUARTERLY ||
            selection.project.reportType === ReportType.MONTHLY ||
            selection.project.reportType === ReportType.CUSTOM;

        let reportSubpath = `/${Paths.GENERAL_INFORMATION}`;
        if (annualReportMeta && annualReportMeta.isSealed) {
            this.annualReportNavigationProvider.setActiveArNavigation([AnnualReportStep.PRINT], true);
            reportSubpath = `/${Paths.PRINT}`;
        }

        if (selection.area === 'report' || isInterimReport) {
            if (this.isCpmmActive && this.isMandateAndTaskManagementEnabled && !isInterimReport) {
                this.router.navigateByUrl(
                    `${newUrl}/${selection.project.projectId
                    }/cpmm/report${reportSubpath}?backTarget=${encodeURIComponent(backroute)}`,
                );
            } else {
                this.router.navigateByUrl(
                    `${newUrl}/${selection.project.projectId}${reportSubpath}?backTarget=${encodeURIComponent(
                        backroute,
                    )}`,
                );
            }

            return;
        }
        // The closing's own gate decides between the setup wizard and the overview.
        if (selection.area === 'closing') {
            this.router.navigateByUrl(
                `${newUrl}/${selection.project.projectId}/abcp/${Paths.CLOSING}?backTarget=${encodeURIComponent(backroute)}`,
            );
            return;
        }
        if (selection.area === WorkflowArea.CLOSING_PROCESS) {
            this.router.navigateByUrl(
                `${newUrl}/${selection.project.projectId}/cpmm/${Paths.CLOSING_WORKFLOW
                }?backTarget=${encodeURIComponent(backroute)}`,
            );
            return;
        }
        if (selection.area === WorkflowArea.MANDATE_MANAGEMENT) {
            this.router.navigateByUrl(
                `${newUrl}/${selection.project.projectId}/cpmm/${Paths.MANDATE_MANAGEMENT
                }?backTarget=${encodeURIComponent(backroute)}`,
            );
            return;
        }

        if (!(annualReportMeta && annualReportMeta.isSealed) && (!this.isCpmmActive || !this.isMandateAndTaskManagementEnabled || isInterimReport)) {
            this.router.navigateByUrl(
                `${newUrl}/${selection.project.projectId}?backTarget=${encodeURIComponent(backroute)}`,
            );
        } else if (!(annualReportMeta && annualReportMeta.isSealed) && (this.isCpmmActive && this.isMandateAndTaskManagementEnabled) && !isInterimReport) {
            this.router.navigateByUrl(
                `${newUrl}/${selection.project.projectId}/cpmm?backTarget=${encodeURIComponent(backroute)}`,
            );
        } else if (this.shouldNavigateToEditPage && annualReportMeta.isSealed) {
            this.annualReportNavigationProvider.setActiveArNavigation([AnnualReportStep.PRINT], true);

            if (this.isCpmmActive && this.isMandateAndTaskManagementEnabled) {
                this.router.navigateByUrl(
                    `${newUrl}/${selection.project.projectId}/cpmm/report/${Paths.PRINT
                    }?backTarget=${encodeURIComponent(backroute)}`,
                );
            } else {
                this.router.navigateByUrl(
                    `${newUrl}/${selection.project.projectId}/${Paths.PRINT}?backTarget=${encodeURIComponent(
                        backroute,
                    )}`,
                );
            }
        }
    }

    private getInviteToReportDialogData(): IInvitationDialogData {
        return {
            titleLocalizationKey: 'aumico_reports_share_annual_report_dialog_title',
            contentMessage: 'aumico_reports_share_annual_report_dialog_content',
            emailInputLabelKey: 'aumico_reports_share_annual_report_dialog_input_label',

            emailInputPlaceholderKey: 'aumico_reports_share_annual_report_dialog_input_placeholder',

            actionBtnTextKey: 'aumico_reports_share_annual_report_dialog_save_button',
            hasMessage: true,
            action: (emails: string[], emailMessage: string) => this.onShareClick(emails, emailMessage),
        };
    }

    private onShareClick(emails: string[], emailMessage: string): void {
        this.invitationDialogRef.close();
        this.shareHandler(emails, emailMessage);
    }

    private resetNeededStores() {
        this.resetStoreService.resetCompanies();
        this.resetStoreService.resetTemplates();
        this.resetStoreService.resetNotes();
        this.resetStoreService.resetAnnualReportNavigation();
        this.resetStoreService.resetProjects();
        this.resetStoreService.resetAnnualReports();
    }

    private openPolicyUpdateDialog(): void {
        const dialogRef = this.dialog.open<AcceptPolicyDialogComponent>(AcceptPolicyDialogComponent, {
            disableClose: true,
            width: '600px',
            panelClass: 'custom-modalbox',
            data: { locale: this.language },
        });

        dialogRef.componentInstance.agreeButtonClicked.pipe(untilDestroyed(this)).subscribe(() => {
            this.authProvider.dispatchAgreeToTerms();
        });

        dialogRef.componentInstance.closeButtonClicked.pipe(untilDestroyed(this)).subscribe(() => {
            this.openAcceptPolicyToContinueDialog();
        });

        this.closePolicyDialog.pipe(untilDestroyed(this)).subscribe(() => {
            dialogRef.close();
        });
    }

    private openAcceptPolicyToContinueDialog(): void {
        const dialogRef = this.dialog.open<AcceptPolicyToContinueUsingAumicoDialogComponent>(
            AcceptPolicyToContinueUsingAumicoDialogComponent,
            {
                disableClose: true,
                width: '600px',
                panelClass: 'custom-modalbox',
            },
        );

        dialogRef.componentInstance.acceptPolicyButtonClicked.pipe(untilDestroyed(this)).subscribe(() => {
            this.authProvider.dispatchAgreeToTerms();
        });

        dialogRef.componentInstance.declinePolicyButtonClicked.pipe(untilDestroyed(this)).subscribe(() => {
            dialogRef.close();
            this.router.navigate([`${this.language}/logout`]);
        });

        this.closePolicyDialog.pipe(untilDestroyed(this)).subscribe(() => {
            dialogRef.close();
        });
    }

    public onNumberOfDocumentsPerPageChanged(numberOfDocumentsPerPage: number): void {
        this.userPreferredNumberOfDocumentsPerPage = numberOfDocumentsPerPage;
        this.authProvider.dispatchUpdateUserPreferences({
            ...this.userPreferences,
            numberOfDocumentsPerPage: numberOfDocumentsPerPage,
        });
        this.localStorageService.setUserPrefrences({
            ...this.userPreferences,
            numberOfDocumentsPerPage: numberOfDocumentsPerPage,
        });
    }

    public onCompanySelected(company: ICompanyNameIdLegalFormDTO): void {
        this.companiesProvider.dispatchCompanyById(company._id);
    }

    public onReportTypeSelected(type: ReportType): void {
        this.reportType = type;
        this.dispatchNextBalanceSheetDateForCompany(type);
    }

    private dispatchNextBalanceSheetDateForCompany(type: ReportType): void {
        const companyId = this.selectedCompanyDto?._id;
        if (!companyId) {
            // IF selectedCompanyDto is not yet set (e.g., due to async loading), store the type so that as soon as we have the selected compoany, we can dispatch
            this.pendingReportType = type;
            return;
        }

        this.pendingReportType = undefined;
        this.annualReportProvider.dispatchGetNextBalanceSheetDateForCompanyById(companyId, type);
    }

    public onBalanceSheetDateSelected(balanceSheetDate: Date): void {
        this.balanceSheetDate = balanceSheetDate;
    }

    public closeNewProjectDialog(closeAndSave: boolean): void {
        this.showCreateProjectPopup = false;
        if (closeAndSave) {
            const setupData: ISetupData = {
                company: this.selectedCompanyDto,
                balanceSheetDate: this.balanceSheetDate.toISOString(),
                mandateManagementWorkflow:
                    this.mandateManagementWorkflow ??
                    WorkflowConfigurationSelectionEnum.RESET_TO_STANDARD_CONFIGURATION,
                closingWorkflow:
                    this.closingWorkflow ?? WorkflowConfigurationSelectionEnum.RESET_TO_STANDARD_CONFIGURATION,
                reportType: this.reportType ?? ReportType.ANNUAL,
                fxEnabled: this.selectedCompanyDto?.fx?.enabled === true,
            };
            this.createAnnualReport(setupData);
        }
    }

    public openCreateProjectDialog(): void {
        this.showCreateProjectPopup = true;
    }

    sortProjects(sortEvent: { sortBy: ProjectSortingProperties | null; sortOrder: SortDirection | null }): void {
        if (sortEvent.sortBy === null || sortEvent.sortOrder === null) {
            this.projectsFilter = {
                ...this.projectsFilter,
                sortBy: undefined,
                sortOrder: undefined,
            };
        } else {
            this.projectsFilter = ProjectsOverviewHelper.buildProjectsFilter(
                this.projectsFilter,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                sortEvent.sortBy,
                sortEvent.sortOrder,
            );
        }
        this.store.dispatch(setProjectsFilter({ filter: this.projectsFilter }));
        this.refetchProjects();
    }

    onDueDateFilterChange(years: number[]) {
        if (years.length === 0) {
            this.projectsFilter = {
                ...this.projectsFilter,
                years: undefined,
                startDate: undefined,
                endDate: undefined,
            };
        } else {
            // Clear start and end date if years are selected
            this.projectsFilter = {
                ...this.projectsFilter,
                startDate: undefined,
                endDate: undefined,
            };
            this.projectsFilter = ProjectsOverviewHelper.buildProjectsFilter(
                this.projectsFilter,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                years,
            );
        }
        this.store.dispatch(setProjectsFilter({ filter: this.projectsFilter }));
        this.refetchProjects();
    }

    onAssigneeFilterChange(userIds: string[]): void {
        this.assigneeFilter = userIds;

        this.projectsFilter = ProjectsOverviewHelper.buildProjectsFilter(
            this.projectsFilter,
            undefined,
            undefined,
            userIds,
        );
        this.store.dispatch(setProjectsFilter({ filter: this.projectsFilter }));
        this.refetchProjects();
    }

    onSearchFilterChangeAssignee(searchTerm: string): void {
        if (searchTerm === '' || searchTerm === null) {
            this.searchedAssigneeOptions = this.assigneeOptions;
            return;
        }
        this.searchedAssigneeOptions = this.assigneeOptions.filter((assignee) =>
            assignee.name.toLowerCase().includes(searchTerm.toLowerCase()),
        );
    }

    onProjectStatusFilterChange(projectStatus: ProjectStatus[]): void {
        if (projectStatus.length === 0) {
            this.projectsFilter = {
                ...this.projectsFilter,
                projectStatus: undefined,
            };
        } else {
        }
        this.projectsFilter = ProjectsOverviewHelper.buildProjectsFilter(
            this.projectsFilter,
            undefined,
            undefined,
            undefined,
            projectStatus,
        );
        this.store.dispatch(setProjectsFilter({ filter: this.projectsFilter }));
        this.refetchProjects();
    }

    onCompanyFilterChange(companyIds: string[]): void {
        this.projectsFilter = ProjectsOverviewHelper.buildProjectsFilter(
            this.projectsFilter,
            undefined,
            undefined,
            undefined,
            undefined,
            companyIds,
        );
        this.store.dispatch(setProjectsFilter({ filter: this.projectsFilter }));
        this.refetchProjects();
    }

    onReportTypeFilterChange(reportTypes: ReportType[]): void {
        this.projectsFilter = ProjectsOverviewHelper.buildProjectsFilter(
            this.projectsFilter,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            reportTypes,
        );
        this.store.dispatch(setProjectsFilter({ filter: this.projectsFilter }));
        this.refetchProjects();

    }

    onSearchFilterChange(searchTerm: string): void {
        if (searchTerm === null) {
            searchTerm = '';
        }
        this.projectsFilter = ProjectsOverviewHelper.buildProjectsFilter(
            this.projectsFilter,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            searchTerm,
        );
        this.store.dispatch(setProjectsFilter({ filter: this.projectsFilter }));
        this.refetchProjects();
    }

    refetchProjects(): void {
        this.offset = 0; // Reset offset for new filter
        const currentContext = this.store.select(selectProjectNavigationContext()).pipe(take(1));
        currentContext.subscribe((context) => {
            debug('refetchProjects Refetching projects with filter:', context.context, this.activeUserAumicoInternalId);
            this.projectsFilter = {
                ...this.projectsFilter,
                limit: this.limit,
                offset: this.offset,
            };

            if (context.context === 'my-projects') {
                // If the context is 'my-projects', we don't save the assignee to the projectsFilter that will be saved in local storage
                const temporaryFilter = {
                    ...this.projectsFilter,
                    assignee: [this.activeUserAumicoInternalId],
                };
                this.store.dispatch(ProjectsOverviewActions.loadProjectsOverview({ filter: temporaryFilter }));
            } else {
                this.store.dispatch(ProjectsOverviewActions.loadProjectsOverview({ filter: this.projectsFilter }));
            }
        });
    }

    onSearchFilterChangeCompanies(searchTerm: string) {
        if (searchTerm === '' || searchTerm === null) {
            this.searchedCompaniesOptions = this.companiesOptions;
            return;
        }
        this.searchedCompaniesOptions = this.companiesOptions.filter((company) =>
            company.name.toLowerCase().includes(searchTerm.toLowerCase()),
        );
    }

    onUpdateProjectStatus(data: { projectId: string; status: ProjectStatus; updateTasks: boolean }): void {
        // Loop over workflowData
        // For mandate Management Tasks we use issueId and make an array to use bulkupdate for them
        // For Closing Process we can also use issueId, but here its a section, so we update for the full section directly

        // Get Project Data by its Id
        const projectData = this.projectsOverviewTableData.find((item) => item.projectId === data.projectId);

        if (!projectData.workflowData || !this.isCpmmActive || !this.isMandateAndTaskManagementEnabled) {
            this.store.dispatch(ProjectsOverviewActions.updateProjectStatus(data));
            return;
        }

        let mandateManagementTaskIds: string[] = [];
        let closingSectionIds: string[] = [];
        for (const item of projectData.workflowData) {
            if (item.area === WorkflowArea.MANDATE_MANAGEMENT) {
                for (const task of item.issuesDetails) {
                    mandateManagementTaskIds.push(task.issueId);
                }
            } else if (item.area === WorkflowArea.CLOSING_PROCESS) {
                for (const section of item.issuesDetails) {
                    closingSectionIds.push(section.issueId);
                }
            }
        }
        if (data.status === ProjectStatus.DONE) {
            const enrichedData = {
                ...data,
                mandateManagementTaskIds,
                closingSectionIds,
            };
            this.store.dispatch(ProjectsOverviewActions.updateProjectStatus(enrichedData));
        } else {
            this.store.dispatch(ProjectsOverviewActions.updateProjectStatus(data));
        }
    }

    onDeleteProject(projectId: string): void {
        this.store.dispatch(ProjectsOverviewActions.deleteProject({ projectId }));
    }

    goToCompanies() {
        this.router.navigate([`${this.language}/${Paths.HOME}/${Paths.COMPANIES}/${Paths.OVERVIEW}`]);
    }

    addNewCompany() {
        this.router.navigate([`${this.language}/${Paths.HOME}/${Paths.COMPANIES}/${Paths.ADD}`]);
    }

    onSubjectToggle(value: string): void {
        if (value === 'PERSON') {
            void this.router.navigate([
                `/${this.localStorageService.getCurrentLanguage()}/${Paths.HOME}/${Paths.PROJECT}`,
                Paths.PERSON_PROJECTS,
            ]);
        }
    }

    onDisplayAllProjects(dispatch: boolean = true): void {
        this.activeNavigation = activeNavigation.ALL_PROJECTS;
        if (dispatch) {
            this.store.dispatch(setProjectNavigationContext({ context: 'all-projects' }));
        }
        const old = this.displayAllProjects;
        this.displayAllProjects = true;
        if (old !== this.displayAllProjects) {
            this.refetchProjects();
        }
    }

    onDisplayMyProjects(dispatch: boolean = true): void {
        this.activeNavigation = activeNavigation.MY_PROJECTS;
        if (dispatch) {
            this.store.dispatch(setProjectNavigationContext({ context: 'my-projects' }));
        }
        const old = this.displayAllProjects;
        this.displayAllProjects = false;
        if (old !== this.displayAllProjects) {
            this.refetchProjects();
        }
    }

    onTagFilterChange(tagIds: string[]): void {
        this.projectsFilter = { ...this.projectsFilter, tagIds: tagIds.length ? tagIds : undefined };
        this.store.dispatch(setProjectsFilter({ filter: this.projectsFilter }));
        this.refetchProjects();
    }

    /** REV-22155 — tag names of each project's company. */
    private withTags(projects: ProjectOverviewTableValue[]): ProjectOverviewTableValue[] {
        return projects.map((project) => ({
            ...project,
            tags: (this.tagIdsByCompanyId.get(project.companyId) ?? [])
                .map((id) => this.tagNamesById[id])
                .filter((name): name is string => !!name),
        }));
    }

    public isAnyFilterActive(): boolean {
        return !!(
            this.projectsFilter.tagIds?.length ||
            this.projectsFilter.startDate ||
            this.projectsFilter.endDate ||
            this.projectsFilter.years?.length ||
            this.projectsFilter.assignee ||
            this.projectsFilter.companyIds?.length ||
            this.projectsFilter.projectStatus ||
            this.projectsFilter.companyName
        );
    }

    // Selection logic methods
    clearAllSelections(): void {
        this.selectedProjects.clear();
        this.allProjectsSelected = false;
    }

    onToggleCheckAllProject(): void {
        if (this.allProjectsSelected) {
            this.clearAllSelections();
        } else {
            this.selectedProjects.clear();

            this.projectsOverviewTableData.forEach((project) => {
                this.selectedProjects.add(project.projectId);
            });
            this.allProjectsSelected = true;
        }
    }

    onToggleCheckProject(projectId: string): void {
        if (this.selectedProjects.has(projectId)) {
            this.selectedProjects.delete(projectId);
            this.allProjectsSelected = false;
        } else {
            this.selectedProjects.add(projectId);
        }
    }

    onActionClicked(actionId: string): void {
        if (actionId === 'STATUS_CHANGE') {
            this.openBulkEditStatus = true;
        } else if (actionId === 'DELETE_PROJECTS') {
            // Action to delete selected projects
            this.openBulkDeleteConfirmationDialog = true;
        } else if (actionId === 'CLOSE_BULK_EDIT') {
            this.clearAllSelections();
        }
    }

    confirmDeleteBulkProjects(): void {
        this.openBulkDeleteConfirmationDialog = false;
        this.store.dispatch(ProjectsOverviewActions.bulkDeleteProjects({ projectIds: Array.from(this.selectedProjects), filter: this.projectsFilter }));
        this.clearAllSelections();
    }

    cancelDeleteBulkProjects(): void {
        this.openBulkDeleteConfirmationDialog = false;
    }

    confirmDeleteWithDependencies(): void {
        this.openBulkDeleteDependencyWarningDialog = false;
        this.store.dispatch(
            ProjectsOverviewActions.confirmBulkDeleteWithDependencies({
                projectIds: this.pendingForceDeleteIds,
                filter: this.projectsFilter,
            }),
        );
        this.store.dispatch(ProjectsOverviewActions.clearBulkDeleteWarnings());
        this.resetBulkDeleteWarningState();
    }

    skipDeleteWithDependencies(): void {
        this.openBulkDeleteDependencyWarningDialog = false;
        this.store.dispatch(ProjectsOverviewActions.clearBulkDeleteWarnings());
        this.resetBulkDeleteWarningState();
    }

    private resetBulkDeleteWarningState(): void {
        this.pendingForceDeleteIds = [];
        this.pendingDependencyWarnings = [];
    }

    getProjectNameById(projectId: string): string {
        return this.projectsOverviewTableData.find((p) => p.projectId === projectId)?.projectName ?? projectId;
    }

    editStatusSelected(): void {
        if (this.bulkEditStatusControl.value) {
            this.openBulkEditStatus = false;

            if (this.isCpmmActive && this.isMandateAndTaskManagementEnabled && this.bulkEditStatusControl.value.id === ProjectStatus.DONE) {
                this.openAutoTaskUpdateDialog = true;
            } else {
                this.onEditStatusConfirm(false);
            }
        }
    }

    onEditStatusConfirm(updateTasks: boolean): void {
        this.openAutoTaskUpdateDialog = false;

        if (this.bulkEditStatusControl.value) {
            this.openBulkEditStatus = false;

            let mandateManagementTaskIds: string[] = [];
            let closingSectionIds: string[] = [];
            if (updateTasks && this.isCpmmActive && this.isMandateAndTaskManagementEnabled) {
                this.selectedProjects.forEach((projectId) => {
                    // Get Project Data by its Id
                    const projectData = this.projectsOverviewTableData.find((item) => item.projectId === projectId);

                    for (const item of projectData?.workflowData) {
                        if (item.area === WorkflowArea.MANDATE_MANAGEMENT) {
                            for (const task of item.issuesDetails) {
                                mandateManagementTaskIds.push(task.issueId);
                            }
                        } else if (item.area === WorkflowArea.CLOSING_PROCESS) {
                            for (const section of item.issuesDetails) {
                                closingSectionIds.push(section.issueId);
                            }
                        }
                    }
                });
            }
            if (this.bulkEditStatusControl.value === ProjectStatus.DONE) {
                this.store.dispatch(
                    ProjectsOverviewActions.bulkUpdateProjectStatus({
                        projectIds: Array.from(this.selectedProjects),
                        status: this.bulkEditStatusControl.value.id,
                        updateTasks: updateTasks,
                        mandateManagementTaskIds,
                        closingSectionIds,
                    }),
                );
            } else {
                this.store.dispatch(
                    ProjectsOverviewActions.bulkUpdateProjectStatus({
                        projectIds: Array.from(this.selectedProjects),
                        status: this.bulkEditStatusControl.value.id,
                        updateTasks: updateTasks,
                        mandateManagementTaskIds,
                        closingSectionIds,
                    }),
                );
            }
            this.clearAllSelections();
            this.bulkEditStatusControl.reset();
        }
    }

    // cleanup: Remove selections for projects that are no longer visible after filtering
    private cleanupInvalidSelections(): void {
        // Get current visible project IDs
        const currentProjectIds = new Set<string>();
        this.projectsOverviewTableData.forEach((project) => {
            currentProjectIds.add(project.projectId);
        });

        // Count selections before cleanup for logging
        const initialProjectSelections = this.selectedProjects.size;

        // Remove project selections that are no longer visible
        this.selectedProjects.forEach((projectId) => {
            if (!currentProjectIds.has(projectId)) {
                this.selectedProjects.delete(projectId);
            }
        });

        // Update allProjectsSelected flag - if any selections were removed or if the number of visible projects changed, it can't be "all selected"
        if (
            this.selectedProjects.size < initialProjectSelections ||
            this.selectedProjects.size !== this.projectsOverviewTableData.length
        ) {
            this.allProjectsSelected = false;
        }

        // If all visible projects are selected after cleanup, update the allProjectsSelected flag
        if (
            this.projectsOverviewTableData.length > 0 &&
            this.selectedProjects.size === this.projectsOverviewTableData.length
        ) {
            this.allProjectsSelected = true;
        }
    }
}
